import Test from './test'
import {startNewTest} from './app'
import ClientSocketConnection from './client-socket'
import * as iframeMessaging from './iframe-messaging'

const CM_URL = '<%ENV= CM_URL %>';
const WSS_URL = `<%ENV= WSS_URL %>`;
let csc

// delaying opening the WebSocket until DOMContentLoaded fixes secure sockets failing to open in Chrome
document.addEventListener("DOMContentLoaded", () => {
  csc = new ClientSocketConnection(WSS_URL)
  iframeMessaging.init(csc, CM_URL)
  iframeMessaging.addParentMessageHandler('NEW_TEST', cmRequestedNewTest)
  addTestListeners()
})

async function cmRequestedNewTest({numQuestions, timestables, specificFacts}) {
  const questions = await csc.request('TEST_QUESTIONS', {numQuestions, timestables, specificFacts})

  if (specificFacts) {
    timestables = new Set()
    for (const fact of specificFacts) {
      fact.split('*').forEach(op => timestables.add(parseInt(op, 10)))
    }
  }

  await startNewTest(timestables, questions)
  iframeMessaging.postMessageToParent('START_TEST')
}

function addTestListeners() {
  Test.eventEmitter.on('TEST_START', () => iframeMessaging.postMessageToParent('START_TEST'))

  Test.eventEmitter.on('TEST_QUESTION_COMPLETED', question => {
    csc.sendMessage('QUESTION_COMPLETED', {
      type: question.type,
      result: question.result,
      answer: question.answer,
      ...question.config
    })
  })

  Test.eventEmitter.on('TEST_EXIT', async () => {
    const pupilData = await csc.request('PUPIL_DATA')
    iframeMessaging.postMessageToParent('EXIT_TEST', pupilData)
  })
}
